import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var Article = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment Article on ComponentPresentationArticle {\n    title\n    content\n  }\n"])));
export default Article;